// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import axios from "axios";
import VueAwesomeSwiper from "vue-awesome-swiper";
import picker from "vue-3d-picker";

Vue.config.productionTip = false;

Vue.use(VueAwesomeSwiper);
Vue.use(picker);

//axios全局配置
window.axios = axios;
// 为避免白屏，取消超时设置。
// axios.defaults.timeout = 10000
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";
axios.defaults.baseURL = "https://node.chezhentong.com/api/"; //接口地址
// axios.defaults.baseURL = 'https://t.api.chezhentong.com/api/'; //测试接口地址

//网关层异常监听
window.addEventListener("unhandledrejection", (event) => {
  const errorURL = event.reason.request.responseURL;
  if (errorURL.indexOf("h5.chezhentong.com") != -1) {
  } else {
    //日志上报
    axios
      .post(`https://h5.chezhentong.com/v2/api/logs/czt-web`, {
        type: "网络层面",
        error: event.reason,
        userAgent: navigator.userAgent,
        OpenId: localStorage.OpenId ? localStorage.OpenId : "",
        url: window.location.href,
        errorURL: errorURL,
      })
      .then((response) => {});
  }
});

Vue.config.errorHandler = function (err, vm, info) {
  axios
    .post(`https://h5.chezhentong.com/v2/api/logs/czt-web`, {
      type: "代码层面",
      error: err.stack,
      userAgent: navigator.userAgent,
      OpenId: localStorage.OpenId ? localStorage.OpenId : "",
      url: window.location.href,
    })
    .then((response) => {});
};
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  template: "<App/>",
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js